module.exports = __webpack_public_path__ + "static/media/calendar-3.ed43afe6.png";